import { getData } from "../../utils/serverHelper";
import { STAFF } from "../../utils/urls";
import { errorMessage } from "../error/action";
import { setErrorAccount, setLoadingAccounts, setSuccessAccounts } from "./reducer";

export const getAccounts = async(dispatch,auth)=>{
    try {
        dispatch(setLoadingAccounts());
        const dataStaff = await getData(STAFF+`/auth/email/business/${auth}`);
        const dataBizz = await getData(STAFF+`/auth/email/${auth}`);
        // console.log(dataStaff,dataBizz);
        dispatch(setSuccessAccounts({business:dataStaff.data,staff:dataBizz.data}));
    } catch (error) {
        errorMessage(error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(setErrorAccount(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}